<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { BContainer } from 'bootstrap-vue-next';
import { useKeyboardClose } from './useKeyboardClose';
import { buttonMessages } from '../../messages';

const props = withDefaults(
  defineProps<{
    modalName: string;
    header?: string;
    message: string | string[];
    details?: string;
    type?: 'info' | 'error';
  }>(),
  {
    header: '',
    details: '',
    type: 'info',
  },
);

const emit = defineEmits<{
  close: [];
}>();

const containerRef = ref<HTMLElement | null>(null);
const isVisible = ref(true);

useKeyboardClose({
  container: () => containerRef.value,
  onEscape: () => handleClose(),
});

const messages = computed(() => {
  return Array.isArray(props.message) ? props.message : [props.message];
});

const headerClass = computed(() => {
  if (props.type === 'error') {
    return 'bg-danger text-light';
  }
  return 'bg-info text-dark';
});

function handleClose() {
  isVisible.value = false;
  emit('close');
}

onMounted(() => {
  if (containerRef.value) {
    containerRef.value.focus();
  }
});
</script>
<template>
  <div v-if="isVisible" class="modal-in-portal">
    <div
      ref="containerRef"
      class="modal show d-block"
      tabindex="-1"
      role="dialog"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header" :class="headerClass">
            <h5 class="modal-title">{{ header }}</h5>

            <button
              type="button"
              class="close"
              :class="{ 'text-white': type === 'error' }"
              :aria-label="buttonMessages.close"
              @click="handleClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <BContainer fluid class="pt-4 pb-1" style="font-size: 1.1rem">
              <p
                v-for="(msg, index) in messages"
                :key="index"
                style="overflow-wrap: anywhere"
              >
                {{ msg }}
              </p>
              <pre
                v-if="details"
                class="alert border bg-light"
                style="
                  max-height: 400px;
                  overflow-y: auto;
                  white-space: pre-wrap;
                  overflow-wrap: anywhere;
                "
                >{{ details }}</pre
              >
            </BContainer>
          </div>

          <div class="modal-footer bg-light text-dark">
            <button
              type="button"
              class="btn btn-primary"
              data-bs-dismiss="modal"
              @click.prevent.stop="handleClose"
            >
              {{ buttonMessages.close }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal-backdrop show" />
  </div>
</template>
